
<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">Training Reporting</h3>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12" *ngIf="(permissions.canRead(permissions.ComponentID.TrainingConfig))">
      <div class="row">
        <div class="col-lg-12">
          <h3>Training Configuration Reports</h3>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.TrainingConfig))"
            (click)="printAllQualsAndQualTasksRequiredByAllEmps()">
            <mat-icon color="primary">print</mat-icon>
            All Quals and Qual Tasks Required by All Employees
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.TrainingConfig))"
            (click)="printAllQualsAndQualTasksByJobTitle()">
            <mat-icon color="primary">print</mat-icon>
            All Quals and Qual Tasks by Job Title
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.TrainingConfig))"
            (click)="printAllQualsAndQualTasksByJobAssignment()">
            <mat-icon color="primary">print</mat-icon>
            All Quals and Qual Tasks by Job Assignment
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.TrainingConfig))"
            (click)="printQualsAndQualTasksByJobTitle()">
            <mat-icon color="primary">print</mat-icon>
            Quals and Qual Tasks by Job Title
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.TrainingConfig))"
            (click)="printQualsAndQualTasksByJobAssignment()">
            <mat-icon color="primary">print</mat-icon>
            Quals and Qual Tasks by Job Assignment
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.TrainingConfig))"
            (click)="printQualsWithNoEmps()">
            <mat-icon color="primary">print</mat-icon>
            Qualifications with no employee's assigned
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.TrainingConfig))"
            (click)="printQualsWithNoQualTasks()">
            <mat-icon color="primary">print</mat-icon>
            Qualifications with no qual tasks assigned
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.TrainingConfig))"
            (click)="printQualTasksNotAssignedToAnyQual()">
            <mat-icon color="primary">print</mat-icon>
            Qual Tasks not assigned to any qualification
          </aims-common-button>
        </div>
      </div>

    </div>

    <div class="col-xs-12" *ngIf="(permissions.canRead(permissions.ComponentID.ReportingTraining))">
      <div class="row">
        <div class="col-lg-12">
          <h3>Training Reports</h3>
        </div>
      </div>
      <div row *ngIf="tenantUsesPsc">
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.EmployeeTraining) ||
                  permissions.canRead(permissions.ComponentID.SelfTrainedCert) ||
                  permissions.canRead(permissions.ComponentID.QualApproval))"
            (click)="printTrainingHistoryByEmpAndOcc()">
            <mat-icon color="primary">print</mat-icon>
            Req'd by OCC Job Title(s) - Employee
          </aims-common-button>
        </div>
      </div>
      <div row >
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.EmployeeTraining) ||
                  permissions.canRead(permissions.ComponentID.SelfTrainedCert) ||
                  permissions.canRead(permissions.ComponentID.QualApproval))"
            (click)="printTrainingHistoryByEmpAndJobTitle()">
            <mat-icon color="primary">print</mat-icon>
            Req'd by Job Title - Employee
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.EmployeeTraining) ||
                  permissions.canRead(permissions.ComponentID.SelfTrainedCert) ||
                  permissions.canRead(permissions.ComponentID.QualApproval))"
            (click)="printOverdueOrComingDueByEmp()">
            <mat-icon color="primary">print</mat-icon>
            Overdue or Coming due - Employee
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.EmployeeTraining) ||
                  permissions.canRead(permissions.ComponentID.SelfTrainedCert) ||
                  permissions.canRead(permissions.ComponentID.QualApproval))"
            (click)="printQualsNotRequiredByEmp()">
            <mat-icon color="primary">print</mat-icon>
            Quals Not Required - Employee
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.EmployeeTraining) ||
                  permissions.canRead(permissions.ComponentID.SelfTrainedCert) ||
                  permissions.canRead(permissions.ComponentID.QualApproval))"
            (click)="printQualTasksNotRequiredByEmp()">
            <mat-icon color="primary">print</mat-icon>
            Qual Tasks Not Required - Employee
          </aims-common-button>
        </div>
      </div>
      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.EmployeeTraining) ||
                  permissions.canRead(permissions.ComponentID.SelfTrainedCert) ||
                  permissions.canRead(permissions.ComponentID.QualApproval))"
            (click)="printSiteOverdueReport()">
            <mat-icon color="primary">print</mat-icon>
            Site Overdue Report
          </aims-common-button>
        </div>
      </div>
    </div>

    <div class="col-xs-12" style="margin-bottom: 20px;">
      <div class="row">
        <div class="col-lg-12">
          <h3>Qualification</h3>
        </div>
      </div>

      <div row>
        <div class="col-xs-2">
          <b><u>Select Qualification :</u></b>
        </div>
        <div class="col-xs-5">
          <aims-lookup
            name="Qualifications"
            [gridText]="'Select a Qualification'"
            [values]="qualValues | async"
            [idPropertyName]="'qualId'"
            [displayPropertyName]="'qualDesc'"
            [(ngModel)]="qualId"
            [columnsInGrid]="qualificationLookupColumns"
            required>
          </aims-lookup>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.ReportingTraining))"
            (click)="printUnQualifiedQual()" [disabled]="qualId == null">
            <mat-icon color="primary">print</mat-icon>
            Unqualified
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.ReportingTraining))"
            (click)="printQualifiedQual()" [disabled]="qualId == null">
            <mat-icon color="primary">print</mat-icon>
            Qualified
          </aims-common-button>
        </div>
      </div>

      <hr style="margin-top:4px;margin-bottom:4px" />

      <div class="row">
        <div class="col-lg-12">
          <h3>Qualification Tasks</h3>
        </div>
      </div>
      <div row>
        <div class="col-xs-2">
          <b><u>Select Qual Task :</u></b>
        </div>
        <div class="col-xs-5">
          <aims-lookup #aimsControl="ngModel"
            [gridText]="'Select a Qualification Task'"
            name="QualificationTasks"
            [values]="qualTaskValues | async"
            [idPropertyName]="'qualTaskId'"
            [displayPropertyName]="'qtDesc'"
            [(ngModel)]="qualTaskId"
            [columnsInGrid]="qualificationTaskLookupColumns"
            required>
          </aims-lookup>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.ReportingTraining))"
            (click)="printRequiredQualTask()" [disabled]="qualTaskId == null">
            <mat-icon color="primary">print</mat-icon>
            Get Required
          </aims-common-button>
        </div>
      </div>

      <div row>
        <div class="col-xs-12 printButton">
          <aims-common-button *ngIf="(permissions.canRead(permissions.ComponentID.ReportingTraining))"
            (click)="printOverdueOrComingDueQualTask()" [disabled]="qualTaskId == null">
            <mat-icon color="primary">print</mat-icon>
            Overdue or Coming due
          </aims-common-button>
        </div>
      </div>

    </div>

  </div>
</div>
